import { render, staticRenderFns } from "./PartnerCallback.vue?vue&type=template&id=6300de64"
import script from "./PartnerCallback.vue?vue&type=script&lang=ts"
export * from "./PartnerCallback.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports